import {
  ChangeDetectionStrategy,
  Component,
  Input,
  signal,
  TemplateRef,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatList, MatListItem } from '@angular/material/list';
import { NgTemplateOutlet } from '@angular/common';

export interface ExpandableListItemTemplateContext {
  $implicit: ExpandableListItem;
  item: ExpandableListItem;
  index: number;
}

export type ExpandableListItem = {
  label: string;
  value: string;
  subItems?: ExpandableListItem[];
  templateName?: string;
};

export type ExpandableListData = {
  totalRow?: {
    value: string;
    label: string;
    positionBottom?: boolean;
  };
  templateName?: string;
  headerTemplate?: string;
  expandableListItems: ExpandableListItem[];
};

@Component({
  selector: 'stena-expandable-list',
  templateUrl: './stena-expandable-list.component.html',
  styleUrls: ['./stena-expandable-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  imports: [MatIconModule, MatList, MatListItem, NgTemplateOutlet],
})
export class StenaExpandableListComponent {
  @Input() listData: ExpandableListData | null = null;
  @Input() isSingleSelect = false;
  @Input() templates: {
    [key: string]: TemplateRef<ExpandableListItemTemplateContext>;
  } = {};

  expandedRow = signal<number[]>([]);

  getClassForHeader(expandableItem: ExpandableListItem): string {
    const base = 'flex flex-row w-full items-center';
    return expandableItem.subItems && expandableItem.subItems.length > 0
      ? `${base} gap-2`
      : `${base} pl-2`;
  }

  getTemplate(
    templateName?: string,
    useListTemplateNameFallback = false
  ): TemplateRef<ExpandableListItemTemplateContext> | null {
    const resolvedTemplateName =
      templateName ||
      (useListTemplateNameFallback ? this.listData?.templateName : undefined);
    if (!resolvedTemplateName) {
      return null;
    }

    return this.templates[resolvedTemplateName] ?? null;
  }

  toggleExpanded(index: number) {
    const item = this.listData?.expandableListItems[index];
    if (!item?.subItems) return;
    if (this.expandedRow().includes(index)) {
      this.expandedRow.set(this.expandedRow().filter((i) => i !== index));
    } else {
      this.expandedRow.set(
        this.isSingleSelect ? [index] : [...this.expandedRow(), index]
      );
    }
  }
}
